import { useEffect, useState } from "react";
//@ts-ignore
import style from "../style/Login.module.css";
import validateOnBlur from "../hook/validateOnBlur";

import {
  TextInput,
  PasswordInput,
  //@ts-ignore
} from "@viuti/recursos";

const EmailPasswordForm = ({ loginForm, setLoginForm, error, setError }) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleInputChange = (e, name) => {
    setLoginForm({ ...loginForm, [name]: e.target.value });
  };

  useEffect(() => {
    validateOnBlur(loginForm, setError, error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginForm]);

  return (
    <>
      <div className={style.inputContainer}>
        <TextInput
          label="Correo electrónico"
          placeholder="Ingresa tu correo electrónico"
          value={loginForm.email === null ? "" : loginForm.email}
          handleChange={(e) => handleInputChange(e, "email")}
          touched={loginForm.email !== null}
          useCircleAlert={false}
          id="login_signIn_input_email"
          inputProps={{
            autoComplete: "username",
          }}
        />
        {loginForm.email !== null && (
          <span
            className={`${style.errorMessageContainer} ${
              error.email ? style.errorMessageContainer__visible : ""
            }`}
          >
            <p className={style.errorMessage}>{error.email}</p>
          </span>
        )}
      </div>
      <div className={style.inputContainer}>
        <PasswordInput
          label="Contraseña"
          inputProps={{
            placeholder: "Ingresa tu contraseña",
            value: loginForm.password === null ? "" : loginForm.password,
            onChange: (e) => handleInputChange(e, "password"),
            type: isPasswordVisible ? "text" : "password",
            autoComplete: "current-password",
          }}
          visibility={{
            isVisible: isPasswordVisible,
            setIsVisible: setIsPasswordVisible,
            isToggleAvailable: true,
          }}
          touched={loginForm.password !== null}
          id="login_signIn_input_password"
        />
        {loginForm.password !== null && (
          <span
            className={`${style.errorMessageContainer} ${
              error.password ? style.errorMessageContainer__visible : ""
            }`}
          >
            <p className={style.errorMessage}>{error.password}</p>
          </span>
        )}
      </div>
    </>
  );
};

export default EmailPasswordForm;
